export const contractsData = [
  // 1️⃣ 銷售委託類（賣方委託）
  {
    id: 'c001',
    name: '不動產專任委託銷售契約書',
    category: 'sales-commission',
    description: '房仲專用的不動產委託銷售契約書，屋主專任委託仲介銷售不動產，符合內政部規範的專任委託合約範本',
    price: 700,
    pages: 6,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/87118ced2eced45b267e1c653507f2bd.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c002',
    name: '不動產一般委託銷售契約書',
    category: 'sales-commission',
    description: '房仲契約書範本，屋主一般委託仲介銷售不動產，適合房仲公司使用的委託銷售契約書',
    price: 700,
    pages: 5,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/f43db2d22129df1fcabaf699b1784473.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c003',
    name: '土地專任委託銷售契約書',
    category: 'sales-commission',
    description: '專業房仲契約書，地主專任委託仲介銷售土地，不動產銷售契約範本',
    price: 700,
    pages: 6,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/b52b11cfb18c3dcdfa56ee5f8c1c2ca6.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c004',
    name: '土地一般委託銷售契約書',
    category: 'sales-commission',
    description: '房仲專用契約書，地主一般委託仲介銷售土地，不動產契約書範本',
    price: 700,
    pages: 5,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/7100cf3cc9e5858b2947431fb072d62e.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 2️⃣ 租賃委託與租賃契約類
  {
    id: 'c005',
    name: '不動產專任委託租賃契約書',
    category: 'lease-commission',
    description: '房仲契約書範本，出租方專任委託仲介租賃，專業不動產契約書',
    price: 350,
    pages: 5,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/165ae6eaa7d012d1e7a6978f93cbcf40.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c006',
    name: '不動產一般委託租賃契約書',
    category: 'lease-commission',
    description: '房仲專用契約書，出租方一般委託仲介租賃，不動產契約書範本',
    price: 350,
    pages: 4,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/dd53e9045ee3e88bfe085fd44248fbee.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c007',
    name: '不動產租賃斡旋委託書',
    category: 'lease-commission',
    description: '房仲契約書，承租方委託仲介斡旋租賃，專業契約書範本',
    price: 350,
    pages: 3,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/089e5984d4cd517ccb0ca28b5a665db7.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c008',
    name: '簡易版房屋租賃契約書',
    category: 'lease-commission',
    description: '簡化版住宅租賃契約，房仲專用契約書範本',
    price: 780,
    pages: 4,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/9dac7b5c5457f4d20c3ce32abd76bfd0.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c009',
    name: '住宅租賃定型化契約書',
    category: 'lease-commission',
    description: '符合內政部規範的標準租賃契約，不動產交易定型化契約範本',
    price: 2800,
    pages: 12,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/724e3d82094fa2ae75b8a7705f5094e7.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c010',
    name: '租賃住宅委託管理契約書',
    category: 'lease-commission',
    description: '委託專業管理公司代管租賃住宅，房仲契約書範本',
    price: 1400,
    pages: 8,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/fd17c326c6ce4cb990ddc8f8cabdf5b2.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c011',
    name: '住宅包租契約書',
    category: 'lease-commission',
    description: '包租業者與屋主簽訂的包租契約，專業不動產契約書範本',
    price: 1300,
    pages: 7,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/9960d227c2c19fce5a84b897df22057e.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c012',
    name: '住宅轉租契約書',
    category: 'lease-commission',
    description: '包租業者與承租人簽訂的轉租契約，房仲專用契約書',
    price: 1100,
    pages: 6,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/f7367964e197a3727186e8763f11d7f7.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 3️⃣ 買賣契約類
  {
    id: 'c013',
    name: '不動產買賣契約書',
    category: 'purchase-contract',
    description: '正式不動產買賣簽約使用，房仲買賣契約書範本，符合內政部規範的不動產買賣契約書',
    price: 3300,
    pages: 15,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/c595bb41b67e3741615f0cac5b9898e1.webp'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c014',
    name: '土地買賣契約書',
    category: 'purchase-contract',
    description: '正式土地買賣簽約使用，房仲專用契約書，專業不動產買賣契約書範本',
    price: 2800,
    pages: 12,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/6eb026b2a02aee9cb3977c2216832597.webp'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c015',
    name: '預售屋買賣契約書',
    category: 'purchase-contract',
    description: '預售屋交易專用契約，房屋買賣契約書範本，符合內政部規範',
    price: 3000,
    pages: 18,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/8620f43fc76bf96ff3c6292c1e399e1f.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 4️⃣ 標的現況／不動產說明文件
  {
    id: 'c016',
    name: '成屋不動產標的現況說明書',
    category: 'property-disclosure',
    description: '成屋現況揭露文件，房仲契約書範本，不動產契約書',
    price: 780,
    pages: 8,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/f9d15fdfcab86cb131c9caa8d8514bfc.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c017',
    name: '成屋不動產說明書',
    category: 'property-disclosure',
    description: '成屋完整不動產說明文件，房仲專用契約書範本',
    price: 780,
    pages: 10,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/97c5a89defce90cbf9c3903f174bf8a9.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c018',
    name: '土地標的現況說明書',
    category: 'property-disclosure',
    description: '土地現況揭露文件，專業不動產契約書範本',
    price: 780,
    pages: 6,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/597c2663dcfe04a98e0ee2aa2d7da203.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c019',
    name: '土地不動產說明書',
    category: 'property-disclosure',
    description: '土地完整不動產說明文件，房仲契約書',
    price: 380,
    pages: 5,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/13ca1b830918cbea5ec685efb9058706.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 5️⃣ 買方／承購相關文件
  {
    id: 'c020',
    name: '買方議價委託書',
    category: 'buyer-documents',
    description: '買方委託仲介議價，房仲專用契約書範本',
    price: 780,
    pages: 3,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/4ca5affea99dd7ce8ba3cd1ba247df8b.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c021',
    name: '不動產承購要約書',
    category: 'buyer-documents',
    description: '買方正式承購意向書，房仲契約書範本',
    price: 780,
    pages: 4,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/ea3e17847fd714834de8dd978ce9a62a.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c022',
    name: '不動產委託代標契約書',
    category: 'buyer-documents',
    description: '委託仲介代為參與法拍或標售，專業不動產契約書範本',
    price: 700,
    pages: 5,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/0b528821df2eecf2259f7449c2454dd5.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 6️⃣ 收款、費用與報酬文件
  {
    id: 'c023',
    name: '不動產賣方定金收款憑證',
    category: 'payment-documents',
    description: '賣方收取定金的收據憑證，房仲契約書',
    price: 380,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/c0c9b1f7aa5dc75e1b71c4fb401da291.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c024',
    name: '不動產買方定金收款憑證',
    category: 'payment-documents',
    description: '買方支付定金的收據憑證，房仲專用契約書',
    price: 380,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/fbfd9e96581ac9bdee3e7014f9824d98.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c025',
    name: '租賃定金收款憑證',
    category: 'payment-documents',
    description: '租賃定金收據憑證，契約書範本',
    price: 350,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/21e6eb86ad6e5f32e2bf36e0cce8addc.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c026',
    name: '服務費收款憑證',
    category: 'payment-documents',
    description: '仲介服務費收據憑證，房仲契約書',
    price: 160,
    pages: 1,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/ff569a9ad9a08f81a6061a04a2b15746.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c027',
    name: '給付服務報酬承諾書',
    category: 'payment-documents',
    description: '承諾給付仲介服務報酬的文件，房仲專用契約書範本',
    price: 350,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/85e7d26d2dce66e8ad5b235653ed567d.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 7️⃣ 地政士／登記相關文件
  {
    id: 'c028',
    name: '地政士委任書',
    category: 'registration-documents',
    description: '委任地政士辦理登記事務，不動產契約書範本',
    price: 700,
    pages: 3,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/4c4db7218178fb7e25732f2213551953.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c029',
    name: '地政士房地產登記費用明細表',
    category: 'registration-documents',
    description: '登記相關費用明細清單，房仲契約書',
    price: 360,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/b3a326aebbf3fb82c95516d5a6d3d770.jpeg'
    ],
    updatedAt: '2024-02-15'
  },

  // 8️⃣ 其他
  {
    id: 'c030',
    name: '契約內容變更同意書',
    category: 'other-documents',
    description: '契約簽訂後的變更補充文件，房仲契約書範本',
    price: 350,
    pages: 2,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/3e3d13a74344531fe6ae34634272f71d.jpeg'
    ],
    updatedAt: '2024-02-15'
  },
  {
    id: 'c031',
    name: '仲介經紀業專用契約書封面',
    category: 'other-documents',
    description: '契約書專用封面，房仲公司專用',
    price: 400,
    pages: 1,
    region: ['全台適用'],
    previewImages: [
      'https://static.readdy.ai/image/4e3cf408545f0c2efa1ef6dd2e77e8cf/a07a5f908982f56e3ecceffa7554cf9a.jpeg'
    ],
    updatedAt: '2024-02-15'
  }
];

export const categoryInfo = {
  'land-sale': {
    name: '土地買賣',
    color: '#2d5016',
    icon: 'ri-map-2-line'
  },
  'land-lease': {
    name: '土地租賃',
    color: '#52c41a',
    icon: 'ri-key-2-line'
  },
  'house-sale': {
    name: '房屋買賣',
    color: '#1a2332',
    icon: 'ri-home-4-line'
  },
  'house-lease': {
    name: '房屋租賃',
    color: '#1890ff',
    icon: 'ri-file-text-line'
  }
};

export const mainCategoryInfo = {
  'sales-commission': {
    name: '銷售委託類',
    description: '屋主／地主委託仲介銷售',
    color: '#2d5016',
    icon: 'ri-file-user-line'
  },
  'lease-commission': {
    name: '租賃委託與租賃契約類',
    description: '出租、承租、代管、包租、轉租',
    color: '#52c41a',
    icon: 'ri-key-2-line'
  },
  'purchase-contract': {
    name: '買賣契約類',
    description: '正式買賣簽約',
    color: '#1a2332',
    icon: 'ri-file-text-line'
  },
  'property-disclosure': {
    name: '標的現況／不動產說明文件',
    description: '揭露屋況、土地現況、交易透明',
    color: '#1890ff',
    icon: 'ri-file-list-2-line'
  },
  'buyer-documents': {
    name: '買方／承購相關文件',
    description: '斡旋、議價、承購意向',
    color: '#722ed1',
    icon: 'ri-user-received-line'
  },
  'payment-documents': {
    name: '收款、費用與報酬文件',
    description: '定金、服務費、報酬承諾',
    color: '#fa8c16',
    icon: 'ri-money-dollar-circle-line'
  },
  'registration-documents': {
    name: '地政士／登記相關文件',
    description: '過戶、登記、地政士配合',
    color: '#13c2c2',
    icon: 'ri-government-line'
  },
  'other-documents': {
    name: '其他',
    description: '補充、變更、特殊用途',
    color: '#8c8c8c',
    icon: 'ri-folder-line'
  }
};
